/**
 * @Description 加盟+直营模式-拓店管理-拓店任务-接口
 */

import { get, post } from '@/common/request/index';

/**
 * @description 拓店任务列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/59415
 */
export function getExpansionClusterAndDirectTaskList(params?:any) {
  return post('/clusterAndDirect/task/page', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 创建基诺浦拓店任务
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/73688
 */
export function postExpansionClusterAndDirectTaskCreate(params?:any) {
  return post('/clusterAndDirect/task/create', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 拓店任务详情
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/73695
 */
export function getClusterAndDirectTaskDetail(params?:any) {
  return get('/clusterAndDirect/task/detail', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 更新拓店任务
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/73765
 */
export function postTaskUpdate(params?:any) {
  return post('/clusterAndDirect/task/update', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 导出
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/73709
 */
export function postTaskExport(params?:any) {
  return post('/clusterAndDirect/task/export', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 指派拓店任务
 *  文档同/api/direct/task/assign
 * @yapi https://yapi.lanhanba.com/project/546/interface/api/72204
 */
export function clusterAndDirectTaskAssign(params?: any) {
  return post('/clusterAndDirect/task/assign', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}
